export const iconFontVersion = '3.18';
export const IconFontFileName = `audi-iconfont_${iconFontVersion}.woff2`;
export const baseIconFontPath = `assets/webfonts/icon/${IconFontFileName}`;
//# sourceMappingURL=iconFontVersion.mjs.mjs.map